module.exports = __webpack_public_path__ + "media/living.985737cf.svg";